/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { tenantsCreate } from "../../funcs/tenantsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PostApiLeadScraperMicroserviceApiV1OrganizationsOrganizationIdTenantsRequest$inboundSchema,
};

export const tool$tenantsCreate: ToolDefinition<typeof args> = {
  name: "tenants_create",
  description: `Create a new tenant

Creates a new tenant in the system`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
